import React from 'react';
import Box from '@mui/material/Box';

interface IAuthModalFormContainerProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const TabsComponentContainer = ({
  children,
  value,
  index,
}: IAuthModalFormContainerProps) => (
  <Box hidden={value !== index} width="100%" pt="45px" height="100%">
    {children}
  </Box>
);
